import React from 'react'
import "./signup.css"
import { NavLink } from 'react-router-dom';
function Register() {
  return (
        <div>
          <div class="ian-container">
          <div class="ian-container-left">
            <div class="ian-content">
              <div class="ian-header">
                            <NavLink to="/" className="navlink">
                
                <span class="ian-back-btn">
                  <i class="ri-arrow-left-line"></i>
                </span>
                </NavLink>
                <NavLink className="navlink" to="/login"><span class="ian-register"> Login </span></NavLink>
              </div>
              <div class="ian-form-content">
                <h3 class="ian-form-title">Create an Account</h3>
                <p class="ian-form-subtitle">
                  Welcome! Please fill in the form below to create
                  account.<br/>
                                <span className='mobile-registration'> <span className='or'> Or </span>
                       <NavLink to="/login" className="navlink"><span class="ian-register">Login </span></NavLink></span>
                </p>
                <form action="">
                  <input type="text" placeholder="Fist name" class="ian-input" required />
                  <input type="text" placeholder="Second name" class="ian-input" required/>

                  <input type="password" placeholder=" Create Password" class="ian-input" required/>
                  <input type="password" placeholder=" Confirm Password" class="ian-input" required/>

                  <button class="ian-submit-btn" type="submit">Sign Up</button>
                </form>
                <span class="ian-bottom-line"></span>
                <p class="ian-footer-title">You can also Register with:</p>
                <div class="ian-social-icons">
                  <i class="ri-facebook-box-fill"></i>
                  <i class="ri-google-fill"></i>
                  <i class="ri-twitter-fill"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="ian-container-right">
            <div class="ian-image">
              <h3>Start your journey</h3>
              <p>
                Start creating your amazing home with us! Login into your account.
              </p>
            </div>
          </div>
        </div>
        </div>
  )
}

export default Register
